import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { Typography } from "@mui/material";

// Components
import { Home } from "./components/Home";
import { ContactUs } from "./components/ContactUs";
import { Enrollment } from "./components/Enrollment";
import { Graduates } from "./components/Graduates";
import { RulesProtocol } from "./components/RulesProtocol";
import { NavigationBar } from "./components/NavigationBar";
import { Homework } from "./components/Homework";
import { Login } from "./components/Login";
import { AuthGuard } from "./layout/AuthGuard";
import { useAuth } from "./hooks/useAuth";

// Styles
import "./App.css";
import { CombinedScoreboard } from "./components/CombinedScoreboard";

function App() {
  const { isLoggedIn } = useAuth();
  
  return (
    <>
      <div className="App">
        <HashRouter>
          {isLoggedIn && <NavigationBar />}
          <Routes>
            <Route path="/" element={isLoggedIn ? <Home /> : <Login />} />
            <Route path="/enrollment" element={
              <AuthGuard>
                <Enrollment />
              </AuthGuard>
            } />
            <Route path="/rules-protocol" element={
              <AuthGuard>
                <RulesProtocol />
              </AuthGuard>
            } />
            <Route path="/scoreboard" element={
              <AuthGuard>
                <CombinedScoreboard />
              </AuthGuard>
            } />
            <Route path="/graduates" element={
              <AuthGuard>
                <Graduates />
              </AuthGuard>
            } />
            <Route path="/homework" element={
              <AuthGuard>
                <Homework />
              </AuthGuard>
            } />
            <Route path="/contact-us" element={
              <AuthGuard>
                <ContactUs />
              </AuthGuard>
            } />
            {/* <Route path="/class4-callout" element={
              <AuthGuard>
                <Class4CalloutDemo />
              </AuthGuard>
            } /> */}
            {/* <Route path="/callout" element={
              <AuthGuard>
                <CalloutPairings />
              </AuthGuard>
            } /> */}
          </Routes>
        </HashRouter>
      </div>
      <footer className="footer">
        <Typography
          variant="subtitle1"
          sx={{ fontSize: "clamp(0.7rem, 1.8vw, 1rem)", color: "white" }}
          color="textSecondary"
          align="center"
        >
          © {new Date().getFullYear()} Canada Elite Circle. All rights reserved - For WFG Coded Associates
          Internal Use Only
        </Typography>
      </footer>
    </>
  );
}

export default App;
